var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ContentHeader',[_c('h1',[_vm._v("Sidan hittades inte")])]),_c('p',[_vm._v(" Sidan du försökte nå verkar inte finnas. ")]),_c('AppMenu',{attrs:{"extraMenuAtBottom":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }